import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';
import fetch from 'cross-fetch';

const getGraphUri = () => {
    switch (window.location.host) {
        case 'icsc.com':
        case 'www.icsc.com':
            return 'https://graph.icsc.com';
        case 'stage.icsc.com':
            return 'https://graph.stage.icsc.com';
        case 'webdev.icsc.com':
            return 'https://graph.webdev.icsc.com';
        case 'sync.icsc.test':
        case 'icsc.test':
        case 'icsc.test:3000':
        case 'localhost:55607':
            return 'https://graph.icsc.test';
        default:
            return 'https://graph.stage.icsc.com';
    }
};

const link = new HttpLink({ uri: getGraphUri(), fetch, credentials: 'include' });

// https://www.apollographql.com/docs/react/caching/cache-field-behavior/
// switched from id to recordId for favoriting
// merge: false - Equivalent to what happens if there is no custom merge function.
const client = new ApolloClient({
    link,
    cache: new InMemoryCache({
        typePolicies: {
            Company: {
                keyFields: ['recordId'],
            },
            Event: {
                keyFields: ['recordId'],
                fields: {
                    events: {
                        merge: false,
                    },
                },
            },
            // getting "Cache data may be lost when replacing the events field of a Query object."
            // When removing event from favorites. I don't know exactly why "Query" is a type
            // but this overrides it and just accepts the incoming data, which should
            // be fine because that doesn't change
            Query: {
                fields: {
                    events: {
                        merge: false,
                    },
                    publications: {
                        merge: false,
                    },
                    contacts: {
                        merge(existing, incoming) {
                            return incoming.filter(s => s !== null);
                        },
                    },
                    companies: {
                        merge(existing, incoming) {
                            return incoming.filter(s => s !== null);
                        },
                    },
                    articles: {
                        merge(existing, incoming) {
                            return incoming.filter(a => a !== null);
                        },
                    },
                    savedProperties: {
                        merge(existing, incoming) {
                            return incoming.filter(s => s !== null);
                        },
                    },
                    savedSearches: {
                        merge(existing, incoming) {
                            return (incoming || []).filter(s => s !== null);
                        },
                    },
                    properties: {
                        merge: false,
                    },
                    viewerEvents: {
                        merge(existing, incoming) {
                            // staging returns empty events as null, filter them out
                            return incoming.filter(e => e !== null);
                        },
                    },
                },
            },
            Contact: {
                keyFields: ['recordId'],
                fields: {
                    events: {
                        merge(existing, incoming) {
                            // staging returns empty events as null, filter them out
                            return incoming.filter(e => e !== null);
                        },
                    },
                },
            },
            Article: {
                keyFields: ['recordId'],
            },
            // this was causing the address to be the same for all saved contacts.
            // It was originally added to fix some caching issues.
            // Addresses are no longer entities unto themselves and will never have IDs.
            // Cache issue was not flagging in console, but if it does pop up -
            // maybe combine member id and purpose for custom id?
            // Address: {
            //     keyFields: ['purpose'],
            // },
            Publication: {
                keyFields: ['recordId'],
            },
            College: {
                keyFields: ['code'],
            },
            Property: {
                keyFields: ['id'],
            },
            SitePlan: {
                keyFields: ['id'],
            },
            PropertyPhoto: {
                keyFields: ['id'],
            },
        },
    }),
});

export default client;
